module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_4_wl-50db3e4b37b836cfd0da0ea954dcaed4.svg";